import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.Tooltip),
  () => import('./Tooltip'),
  (Tooltip) => {
    ComponentUtil.binder(Hooks.Tooltip, Tooltip);
  },
);
